<template>
    <div data-v-15e2b8ce="" data-v-75ae43fa="" tabindex="0" class="home-image col-12">
        <p v-if="isJACareerApp" class="header-title"><span class="header-before">WELCOME TO</span>JA Future
            by Design: Careers</p>
        <p v-if="isJAEntrepreApp" class="header-title"><span class="header-before">WELCOME TO</span>JA Future
            by Design: Entrepreneurship</p>
        <div class="gradient-overlay"></div>
        <img  src="../Images/mask.png" class="image image-bottom">
        <img v-if="isJACareerApp" src="../Images/career-home-image.jpg" alt="Image home" class="image">
        <img v-if="isJAEntrepreApp" src="../Images/entrep-home-image.jpg" alt="Image home" class="image">
    </div>
</template>

<script>

    export default {
        name: "HomeHeader",
    }

</script>

<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"

    .home-image
        padding 0
        overflow hidden
        height 320px
        margin-top 60px
        position relative
        min-width 480px

    .image
        object-fit cover
        height 100%
        width 100%
        min-width 480px

    .gradient-overlay
        width 100%
        min-width 480px
        height 320px
        position absolute
        left 0
        background linear-gradient(65deg, rgba(244,240,239,1)0%, rgba(244,240,239,1)30%, rgba(244,240,239,0)40%);

    .image-bottom
        width 100%
        min-width 480px
        height auto
        max-height 35px
        position absolute
        bottom 0

    .header-title
        position absolute
        margin 0
        left 8%
        top 55px
        width 320px
        line-height 42px !important
        font font-poppins-semibold
        font-size 42px
        color color-dark
        z-index 1

    .header-before
        font-size 18px
        display block
        color color-4

    @media only screen and (max-width:1200px)
        .home-image
            height 150px

        .gradient-overlay
            background linear-gradient(65deg, rgba(244,240,239,1)0%, rgba(244,240,239,1)45%, rgba(244,240,239,0)55%);

        .image-bottom
            max-height 15px

        .header-title
            top 15px
            width 200px

        .header-before
            font-size 15px

    @media (min-width: 760px) and (max-width: 1200px)
        .header-title
            font-size 26px !important
            line-height 26px !important

    @media only screen and (max-width:760px)
        .home-image
            height 15px
            .image
                display none

        .gradient-overlay
            background-image url("../Images/mask-mobile.png")
            background-position center bottom
            background-size 100% 15px
            width 100%
            height 15px

        .header-title
            display: none

</style>
